import { render, staticRenderFns } from "./UpdateVideo.vue?vue&type=template&id=46fb0a2e&"
import script from "./UpdateVideo.vue?vue&type=script&lang=js&"
export * from "./UpdateVideo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports